// extracted by mini-css-extract-plugin
export var copyContent = "socialProof-module--copyContent--ea39b";
export var current = "socialProof-module--current--b2271";
export var firstRender = "socialProof-module--firstRender--694bd";
export var grid = "socialProof-module--grid--050cd";
export var headlineText = "socialProof-module--headlineText--32a34";
export var image = "socialProof-module--image--cd219";
export var imageSlider = "socialProof-module--imageSlider--f4e89";
export var imageWrapper = "socialProof-module--imageWrapper--0aa68";
export var left = "socialProof-module--left--6bec3";
export var previous = "socialProof-module--previous--353a1";
export var progressContainer = "socialProof-module--progressContainer--f7acc";
export var right = "socialProof-module--right--81100";
export var slideButton = "socialProof-module--slideButton--ef214";
export var slideButtonContainer = "socialProof-module--slideButtonContainer--e7683";
export var slideLeft = "socialProof-module--slideLeft--88240";
export var slideRight = "socialProof-module--slideRight--aa902";
export var socialProof = "socialProof-module--socialProof--a6864";
export var spacer = "socialProof-module--spacer--e36a2";
export var wrapper = "socialProof-module--wrapper--fe4b4";